module.exports = __webpack_public_path__ + "img/email-bg.4bbf4942.jpg";